export const track = {
  title: 'Track',

  hero: {
    sinceLastFeed: 'Since the last feeding',
    nextSide: (side: 'left' | 'right'): string =>
      side === 'left' ? 'Left side next' : 'Right side next',
    emptyTitle: 'Ready when you are',
    emptyBody: 'Log the first feeding and we will keep track of the timing for you.',
  },

  cards: {
    feed: 'Feed',
    feedActive: 'Feeding in progress',
    resume: 'Tap to continue',
    diaper: 'Diaper',
    pump: 'Pump',
    sleep: 'Sleep',
    weight: 'Weight',
  },

  feedSheet: {
    title: 'Log a feeding',
    editTitle: 'Edit feeding',
    modeLabel: 'How would you like to log it?',
    modes: {
      timer: 'Timer',
      bottle: 'Bottle',
      manual: 'By hand',
    },
  },

  timer: {
    tapToStart: 'Tap the side your baby starts on. Tap again to pause.',
    session: 'Session total',
    finish: 'Finish feeding',
    discard: 'Discard this feeding',
    confirmDiscard: 'Discard this feeding? The timer will be cleared.',
  },

  bottle: {
    amount: 'Amount',
    contents: 'What is in the bottle?',
    increase: 'Increase amount',
    decrease: 'Decrease amount',
  },

  manual: {
    left: 'Minutes on left',
    right: 'Minutes on right',
  },

  fields: {
    time: 'Time',
    startTime: 'Start time',
    note: 'Note',
    notePlaceholder: 'Anything worth remembering? (optional)',
  },
};
